import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import { questionPropTypes } from '../constants';
import ArticleLink from './ArticleLink';
import FaqH2 from './FaqH2';
import messages from './messages';

const Container = styled.div`
  ${tw`mt-abs8`}
`;

const RelatedQuestionsList = styled.div`
  ${tw`mt-abs3 ml-abs2 mr-abs2`}
`;

const RelatedQuestions = ({ relatedQuestions }) => (
  <Container>
    <FaqH2>
      <FormattedMessage {...messages.relatedQuestions} />
    </FaqH2>
    <RelatedQuestionsList>
      {relatedQuestions.map((question) => (
        <ArticleLink
          key={question.name}
          articleName={question.name}
          articleTitle={question.title}
        />
      ))}
    </RelatedQuestionsList>
  </Container>
);

RelatedQuestions.propTypes = {
  relatedQuestions: PropTypes.arrayOf(questionPropTypes),
};

export default RelatedQuestions;
